import { Native, env } from '@hb/hbridge';
import { compareVersion } from './utils';

class NativeBridge {
  /**
   * 获取登录态
   * @param forceLogin 
   * @returns 
   */
  static async getTokenAndKey(forceLogin?: boolean) {
    return Native.getTokenAndKey({
      needLogin: !!forceLogin,
    });
  }

  /**
   * 复制到粘贴板
   * @param text 
   * @returns 
   */
  static copyToPasteboard(text: string) {
    return Native.callNative({
      classMap: 'business/pet',
      method: 'copyToPasteboard',
      params: {
        text,
      },
    });
  }

  /**
   * 获取token
   * @returns 
   */
  static fetchUserToken() {
    return Native.callNative({
      classMap: 'business/pet',
      method: 'fetchUserToken',
      params: {
      },
    });
  }

  /**
   * 获取标题栏和状态栏高度
   */
  static getStatusBarAndNavBarHeight() {
    const nativeAppVersion = env.appVersion;
    const appVersion = compareVersion(nativeAppVersion, '1.32.5') >= 0;
    if (!appVersion) {
      return Promise.resolve({
        statusBarHeight: 50,
      });
    }
    return Native.callNative({
      classMap: 'business/pet',
      method: 'getStatusBarAndNavBarHeight',
      params: {
      },
    });
  }

  /**
   * 显示隐藏标题栏
   */
  static toggleNavbar(visible: boolean) {
    Native.toggleNavBar({
      isShow: !!visible,
    });
  }
}

export default NativeBridge;
